import type { IListenViewModel } from 'core'

export function useRecordingData(id: string, {
  /** Track listen page event */
  trackEvent = false
} = {}) {
  function getData() {
    let headers = {}

    /** SSR: forward client request headers to server */
    if (import.meta.server) {
      const data = useRequestHeaders()

      headers = {
        'user-ip': data['x-forwarded-for'],
        'user-agent': data['user-agent'],
        'host': data.host,
        'referer': data.referer
      }
    }

    return api.audio.getPublic(id, { headers, trackEvent })
  }

  // Return from server
  return useAsyncData<IListenViewModel>(`listen:${id}`, getData, {
    getCachedData(key, nuxt) {
      const data = nuxt.isHydrating ? nuxt.payload.data[key] : nuxt.static.data[key]

      if (data)
        return data

      // Return form cache if synced
      // Client side
      if (import.meta.client) {
        const { settings, user, isSynced } = useSession()
        const db = useAudioFolders()
        const audio = db.getItem(id)

        if (audio && isSynced) {
          console.log(`${id} recording data loaded from cache`)

          return {
            audio,
            user,
            settings: {
              name: (audio.isReply ? audio.email : user.name) || 'Someone',
              ...settings.defaults,
              ...settings.getAppSettings('listenPage')
            }
          }
        }
      }
    }
  })
}
